import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import ui_DesignModalQuery from './src/ui/__generated__/ui_DesignModalQuery$parameters';

export const designModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-design-modal" */ './src'),
	),
	getPreloadProps: ({
		siteAri,
		issueAri,
		cloudId,
		designAri,
	}: {
		siteAri: string;
		issueAri: string;
		designAri?: string;
		cloudId: string;
	}) => ({
		queries: {
			designModal: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters: ui_DesignModalQuery,
				variables: {
					siteAri,
					issueAri,
					cloudId,
					designAri,
				},
			},
		},
	}),
});
